module.exports = {
  "calendar": "Kalender",
  "day": "p\xE4ev",
  "dayPeriod": "enne/p\xE4rast l\xF5unat",
  "endDate": "L\xF5ppkuup\xE4ev",
  "era": "ajastu",
  "hour": "tund",
  "minute": "minut",
  "month": "kuu",
  "second": "sekund",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Valitud kuup\xE4ev: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Valitud vahemik: ".concat(args.startDate, " kuni ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Valitud aeg: ".concat(args.time);
  },
  "startDate": "Alguskuup\xE4ev",
  "timeZoneName": "ajav\xF6\xF6nd",
  "weekday": "n\xE4dalap\xE4ev",
  "year": "aasta"
};